import { createContext, useContext } from 'react';
import type { MediaLibraryTheme } from '../types';

const ThemeContext = createContext<MediaLibraryTheme>('plain');

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({
  children,
  theme,
  className,
}: {
  children: React.ReactNode;
  theme: MediaLibraryTheme;
  className?: string;
}) => {
  return (
    <ThemeContext.Provider value={theme}>
      <div className={className} data-zpr-theme={theme}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};
